<template lang="pug">
  section.lt-header-bar
    hr.divisor
    .container
      .row
        .col.wrap
          a.logo-latercera(href='http://mtonline.latercera.com')
            img(src="assets/images/logos-white/mtonline.svg", alt="MT Online")

          .menu-ellipsis
            nav
              a(href='http://www.latercera.com')
                font-awesome-icon(icon="home")
                |   La Tercera
              a(href='http://mtonline.latercera.com/categorias/test-drive/') Test Drive
              a(href='http://mtonline.latercera.com/categorias/lanzamientos/') Lanzamientos
              a(href='http://mtonline.latercera.com/categorias/salones/') Salones
              a(href='http://mtonline.latercera.com/categorias/noticias/') Noticias
              a(href='http://mtonline.latercera.com/categorias/videos/') Videos
              a(href='http://mtonline.latercera.com/categorias/galerias/') Galerías
              a(href='http://mtonline.latercera.com/categorias/motorsport/') Motorsport
              a(href='http://mtonline.latercera.com/categorias/auto-clasico/') Auto Clásico
              a(href='http://mtonline.latercera.com/categorias/mtmag/') MT MAG

            //- form#searchform.searchform(role='search', method='get', action='http://mtonline.latercera.com/')
            //-   input#buscador(type='text', value='', placeholder='Buscar', name='s')

    hr.divisor
</template>

<script>


  export default  {
    name: 'lt-header-bar',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style lang="scss">
  .divisor{
    border-width: 1px 0 0;
    border-color: #3f3f3f;
    border-style: solid;
    margin: 0;
  }
  .lt-header-bar {

    .container{
      padding: 0 1rem;
    }
    &.fixed{
      position: fixed;
      z-index: 5;
      top: 0;
      left: 0;
      width: 100%;
    }
    will-change: transform;
    transition: transform .4s;
    .wrap{
      padding-top: 20px;
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .logo-latercera{
      width: 165px;
      margin: 0;
      img{
        display: block;
        width: 150px;
        margin: 0;
      }
    }
    .menu-ellipsis{
      white-space: nowrap;
      overflow: hidden;
      position: relative;
      display: table-cell;
      padding-left: 2rem;
      &:after{
        display: none;
        content: "";
        background: linear-gradient(to right, transparent 0%,#282d2e 100%);
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 15px;
      }
    }
    nav{
      display: inline;
      align-items: center;
      justify-content: center;
      a{
        color: white;
        font-size: 13.5px;
        line-height: 19.2857px;
        text-decoration: none;
        text-transform: uppercase;
        transition: all .3s ease;
        font-family: 'Open Sans', sans-serif;
        padding-left: 0.8rem;
        padding-right: 0.8rem;
        -webkit-font-smoothing: antialiased;
        &:hover{
          color: lighten(#1b3043, 40%);
          text-shadow: 1px 1px 0 black;
        }
      }
    }
  }
</style>
